import { createRequest } from "helpers/tools";

export const getDestinationTrackerEvent = async (
  source_tracker_id,
  code,
  destination_tracker_id
) => {
  return await createRequest({
    suffix: "events",
    method: "get",
    params: {
      source_tracker_id,
      destination_tracker_id,
      source_event_code: code,
    },
    handleError: false,
  });
};

export const getSourceTrackerEvent = async (trackerId, sourceEventId) => {
  return await createRequest({
    suffix: `events/history/${trackerId}/${sourceEventId}`,
    method: "get",
    handleError: false,
  });
};

export const getTrackerDetailNew = async (id) => {
  return await createRequest({
    suffix: `trackers/${id}`,
    method: "get",
    handleError: false,
  });
};
